/**
 * Whether the body-composition sheet is open.
 *
 * A store rather than local state because three places open it — the weight
 * card in Tendencijos, the Svoris row on Today, and the tap on her push, which
 * arrives as `?body=1` before any screen has mounted — and the sheet itself is
 * hosted once, at the shell, so it can open over whichever tab is showing.
 */

import { create } from 'zustand'

interface BodySheetState {
  open: boolean
}

export const useBodySheet = create<BodySheetState>(() => ({ open: false }))

export function openBodySheet(): void {
  useBodySheet.setState({ open: true })
}

export function closeBodySheet(): void {
  useBodySheet.setState({ open: false })
}
